import { useGlobalContext } from '../context'

function Villager() {
    const {index,players, openWaitingScreen,turns, guard, vote} = useGlobalContext();
    let currentPlayer = players[index];
    return (
        <div className='container border'>
            <h4 className='text-center'>{currentPlayer.name}(Plague Doctor)</h4>
            <p className='text-center'>You may look like a bad guy and, but you actually are a mysterious doctor who doesn't like to show his face,
            and you are here to save the poor villagers. Each turn, you can select a player to save from death(yourself included).Don't let the vampires figure out who you are, or you'll
            end up dead immediately!Note:Dead fuckers can't be guarded.</p>
            <div className='d-flex'>
                <img src={`./img/${currentPlayer.class}.png`} alt="" />
                <div className='btn-holder'>{
                    players.map((player, index) => {
                            return (
                                <button disabled={vote ? 'disabled' : ''} className={turns === 0 ? 'hidden' : 'btn btn-success'} onClick={(e) => { guard(index); e.target.classList.add('selected')}} key={index}>{`${player.name}`}</button>)
                    })
                }
                </div>
            </div>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default Villager;